function ReplaceAll(str) {
    /* space */
    str = str.replace(/\{\}/g, '&nbsp;')
    /* minus */
    str = str.replace(/\{\-\}/g, '&minus;')
    /* times */
    str = str.replace(/\{\x\}/g, '&times;')
    /* add */
    str = str.replace(/\{\+\}/g, '&plus;')
    /* plus-minus sign */
    str = str.replace(/\{\+-\}/g, '<span style="position: relative;top: -0.14em;">&plusmn;</span>')
    /* almost equal to */
    str = str.replace(/\{\~=\}/g, '&asymp;')
    /* number 5 tally mark */
    str = str.replace(/\{5\}/g, '<div class="tally_mark">||||<div class="tally_mark_line">|</div></div>')
    /* italic */
    str = str.replace(/\{i:([^\}]+)\}/g, '<i>$1</i>')
    /* bold */
    str = str.replace(/\{b:([^\}]+)\}/g, '<span style="font-weight: bold;">$1</span>')
    /* algebra */
    str = str.replace(/\{a:([^\}]+)\}/g, '<i style="font-family: serif;font-size: 1.2em">$1</i>')
    /* algebra letter recurring dot above letter */
    str = str.replace(/\{ar:([^\}]+)\}/g, '<i style="font-family: serif;font-size: 1.2em">$1</i><span style="position: relative;top: -0.95em;left: -0.4em;letter-spacing: -1em;">.</span>')
    /* recurring dot above number */
    str = str.replace(/\{r:([^\}]+)\}/g, '$1<span style="position: relative;top: -0.85em;left: -0.4em;letter-spacing: -1em;">.</span>')
    /* sup */
    str = str.replace(/\{sup:([^\}]+)\}/g, '<sup>$1</sup>')
    /* sub */
    str = str.replace(/\{sub:([^\}]+)\}/g, '<sub>$1</sub>')
    /* sup/sub */
    str = str.replace(/\{spb:([^\}]+)\|([^\}]+)\}/g, '<sup>$1</sup><sub style="position: relative; left: -0.5em; top: 0.2em; letter-spacing: -0.5em;">$2</sub>')
    /* sup fraction */
    str = str.replace(/\{supf:([^\}]+)\}/g, '<sup style="position: relative; left: -0.2em; top: -0.3em;">$1</sup>')
    /* cube root - works with anynumber */
    str = str.replace(/\{cr:([^\}]+)\}/g, '<sup style="position:relative; left:0.6em; top:-0.5em; font-size:0.6em;">$1</sup>')
    /* square root */
    str = str.replace(/\{sq:([^\}]+)\}/g, '<span class="square_root_symbol">&radic;</span><span class="square_root">$1</span>')
    /* square root sup */
    str = str.replace(/\{sqsup:([^\}]+)\}/g, '<span class="square_root_symbol" style="font-size: 1.3em;">&radic;</span><span class="square_root" style="border-top: 0.07em solid white;position: relative;left: 0.08em;top: -0.07em;padding-top: 0.2em;">$1</span>')
    /* square root fraction */
    str = str.replace(/\{sqf:([^\}]+)\}/g, '<span class="square_root_symbol" style="font-size: 1.3em;">&radic;</span><span class="square_root" style="border-top: 0.07em solid white;position: relative;left: 0.08em;top: -0.04em;font-size: 1.2em;padding-top: 0em;">$1</span>')
    /* underline */
    str = str.replace(/\{u:([^\}]+)\}/g, '<span style="text-decoration: underline">$1</span>')
    /* long bracket */
    str = str.replace(/\{lb:([^\}]+)\}/g, '<div class="fraction_bracket_format">$1</div>')
    /* vector notation */
    str = str.replace(/\{vn:([^\}]+)\}/g, '<div class="vector_notation">$1</div>')
    return str;
}

export default function Format(str) {
    const that = this
    const slashRegexp = new RegExp(/[\S]+\/[\S]+/g)
    const slash = slashRegexp.test(str)

    if (slash) {
        const vectorRegexp = new RegExp(/\[([\S]+)\/([\S]+)\]/g)
        const fractionMAHQ36Q15Regexp = new RegExp(/([\S]+)\/(\{\-\}\{\})([\S]+)\/([\S]+)/g)
        const fractionMAHQ36Q7Regexp = new RegExp(/([\S]+)\/([\S]+)\/([\S]+)/g)
        const fractionBracketRegexp = new RegExp(/\(([^)(]+)\/([^)(]+)\)/g)
        const divideRegexp = new RegExp(/\{\/\}/g)
        const notFractionRegexp = new RegExp(/\{nf:([^\}]+)\}/g)
        const fractionRegexp = new RegExp(/([\S]+)\/([\S]+)/g)

        str = str.replace(fractionRegexp, (a) => {
            const vector = vectorRegexp.test(a)
            const fractionBracket = fractionBracketRegexp.test(a)
            const fractionMAHQ36Q15 = fractionMAHQ36Q15Regexp.test(a)
            const fractionMAHQ36Q7 = fractionMAHQ36Q7Regexp.test(a)
            const divideSymbol = divideRegexp.test(a)
            const notFraction = notFractionRegexp.test(a)
            if (notFraction) {
                return a.replace(notFractionRegexp, (a, b) => b)
            } else if (vector) {
                return a.replace(vectorRegexp, (a, b, c) => {
                    return '<div class="vector_format"><div class="vector_format_top">' + b + '</div><div class="vector_format_bottom">' + c + '</div></div>';
                });
            } else if (fractionMAHQ36Q15) {
                return a.replace(fractionMAHQ36Q15Regexp, (a, b, c, d, e) => {
                    return '<div class="fraction_format"><div class="fraction_format_top">' + b + '</div><div class="fraction_format_bottom">' + c + '<div class="fraction_format"><div class="fraction_format_top">' + d + '</div><div class="fraction_format_bottom">' + e + '</div></div></div></div>';
                });
            } else if (fractionMAHQ36Q7) {
                return a.replace(fractionMAHQ36Q7Regexp, (a, b, c, d) => {
                    return '<div class="fraction_format"><div class="fraction_format_top">' + b + '</div><div class="fraction_format_bottom"><div class="fraction_format"><div class="fraction_format_top">' + c + '</div><div class="fraction_format_bottom">' + d + '</div></div></div></div>';
                });
            } else if (fractionBracket) {
                return a.replace(fractionBracketRegexp, (a, b, c) => {
                    return '<div class="fraction_bracket_format"><div class="fraction_bracket_format_top">' + b + '</div><div class="fraction_bracket_format_bottom">' + c + '</div></div>';
                });
            } else if (divideSymbol) {
                return Format(a.replace(divideRegexp, (a, b) => '&divide;'));
            } else {
                return a.replace(fractionRegexp, (a, b, c) => {
                    return '<div class="fraction_format"><div class="fraction_format_top">' + b + '</div><div class="fraction_format_bottom">' + c + '</div></div>';
                });
            }
        });
    }
    return ReplaceAll(str)
};
